import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TransactionLimitItem } from '@shared/models';
import { NotificationService } from '@shared/services';
import { TransactionLimitsService } from '@shared/services/transaction/transaction-limits.service';
import { ErrorUtils } from '@shared/utils';

import { TransactionLimitItemComponent } from '../../limits/transaction-limit-item/transaction-limit-item.component';

@Component({
  selector: 'app-business-account-transaction-limits',
  templateUrl: './business-account-transaction-limits.component.html',
  styleUrls: ['./business-account-transaction-limits.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TransactionLimitItemComponent],
})
export class BusinessAccountTransactionLimitsComponent implements OnInit, OnDestroy {
  public businessAccountTransactionLimits: TransactionLimitItem[] = [];

  public loading = true;

  private destroy$ = new Subject<void>();

  constructor(
    public limitsService: TransactionLimitsService,
    public notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.limitsService
      .getBusinessAccountsTransactionLimits()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (limits) => {
          this.businessAccountTransactionLimits = limits || [];
          this.loading = false;
        },
        error: (error) => {
          ErrorUtils.catchError('limitsService.getBusinessAccountsTransactionLimits error', error);
          this.loading = false;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
